export default __webpack_public_path__ + "static/media/140G.fd8d09e6.pdf";